<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="90px">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="分类">
              <el-select
                clearable
                v-model="queryParamForm.categoryId"
                placeholder="请选择"
                @change="changeOtherOptions(true)"
              >
                <el-option
                  v-for="item in queryCategoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="品牌">
              <el-select
                clearable
                v-model="queryParamForm.brandId"
                placeholder="请选择"
                @change="getModelList(true)"
              >
                <el-option
                  v-for="item in queryBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="机型">
              <el-select
                clearable
                v-model="queryParamForm.modelId"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in queryModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="盈利与否">
              <el-select
                clearable
                v-model="queryParamForm.isProfit"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in isProfitList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
         
        </el-row>
        <el-row :gutter="10">
             <el-col :span="6">
                 <el-form-item label="销售订单">
                    <el-input v-model="queryParamForm.saleNo"  clearable></el-input>
                 </el-form-item>
             </el-col>
              <el-col :span="6">
                 <el-form-item label="回收订单">
                    <el-input v-model="queryParamForm.orderNo"  clearable></el-input>
                 </el-form-item>
             </el-col>
              <el-col :span="6">
                 <el-form-item label="IMEI">
                    <el-input v-model="queryParamForm.imei"  clearable></el-input>
                 </el-form-item>
             </el-col>
        </el-row>
        <el-row :gutter="10">
           <el-col :span="6">
            <el-form-item label="销售渠道">
              <el-select
                clearable
                v-model="queryParamForm.saleChannel"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in saleChannelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2.5">
            <el-button type="primary" @click="getSaleOrderListSearch"
              >查询</el-button
            >
          </el-col>
         <el-col :span="3.8">
              <!-- <el-button type="primary" style="margin-left:6px" @click="exportExcelData">批量导出</el-button> -->
              <el-upload
                      style="display:inline"
                      action="aa"
                      :show-file-list="false"
                      :before-upload="importSendInfo">
                <el-button style="margin-left:10px" type="primary" v-loading="fullscreenLoading">批量导入</el-button>
                </el-upload>
           </el-col>
        <el-col :span="3" style="margin-top:10px">
            <a type="primary" @click="getSaleOrderTemplete">导入模板下载</a>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="saleNo" label="销售订单编号"> </el-table-column>
        <el-table-column prop="orderNo" label="回收订单编号"></el-table-column>
        <el-table-column prop="categoryName" label="分类"> </el-table-column>
        <el-table-column prop="modelName" label="机型"> </el-table-column>
        <el-table-column prop="brandName" label="品牌"> </el-table-column>
        <el-table-column prop="imei" label="IMEI"> </el-table-column>
        <el-table-column prop="price" label="回收价格"> </el-table-column>
        <el-table-column prop="salePrice" label="销售价格"> </el-table-column>
        <el-table-column prop="profit" label="销售利润"> </el-table-column>
        <el-table-column prop="saleChannel" label="销售渠道"> </el-table-column>
        <el-table-column prop="saleDate" label="销售日期"> </el-table-column>
         <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="deleteSaleOrder(scope.row.id)" type="text" size="small" style="color: red;">删除</el-button>
              </template>
          </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 查询数据
      queryParamForm: {
        brandId: null,
        categoryId: null,
        modelId: null,
        imei: null,
        isProfit: null,
        orderNo: null,
        saleChannel: null,
        saleNo: null,
      },
      isProfitList:[{id:0,name:"否"},{id:1,name:"是"}],
      saleChannelList:[{id:"自有渠道",name:"自有渠道"}],

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据

      isDlg: false,
      editBasePriceForm: {
        id: null,
        value: null,
        price: 0,
        categoryId: null,
        modelId: null,
        brandId: null,
        gradeId: null,
        serviceId: null,
        skuId:null
      },

      dlgType: "change",

      // 选择
      loading: false,

      queryCategoryOptions: [],
      queryBrandOptions: [],
      queryServiceList: [],
      queryGradeList: [],
      queryModelList: [],

      editGradeList: [],
      editModelList: [],
      editBrandOptions: [],
      editSkuList:[],

      fullscreenLoading:false
    };
  },
  watch: {},
  computed: {},
  methods: {
    //  // click事件
    // exportExcelData () {
    //   let self = this
    //    self.$api
    //     .modelPriceListSearch({
    //       page: self.currentPage,
    //       size: self.tableTotal,
    //       categoryId: self.queryParamForm.categoryId || null,
    //       modelId: self.queryParamForm.modelId || null,
    //       brandId: self.queryParamForm.brandId || null,
    //       imei: self.queryParamForm.imei || null,
    //       isProfit: self.queryParamForm.isProfit || null,
    //       orderNo: self.queryParamForm.orderNo || null,
    //       saleChannel: self.queryParamForm.saleChannel || null,
    //       saleNo: self.queryParamForm.saleNo || null,
    //     })
    //     .then((res) => {
    //       var downLoadTableData = res.data.records || [];
    //       require.ensure([], () => {
    //             const { export_json_to_excel } = require("@/vender/Export2Excel");
    //             const fieldName = ["编号", "定价回收商","机型","SKU名称","品牌","分类","等级","基准价格","状态"];
    //             const filterVal = ["value", "serviceName", "modelName", "skuIdName", "brandName","categoryName","gradeName", "price", "status"];
    //             const data = downLoadTableData.map(v => filterVal.map(j => {
    //               if(j=="status"){
    //                 return v[j]==1?"启用":"禁用"
    //               }
    //               return v[j]
    //             }));
    //             export_json_to_excel(fieldName, data, "机型等级基准定价"+self.$moment(new Date()).format("YYYYMMDDHH:mm:ss"));
    //           });
    //     });
    // },
    deleteSaleOrder(id){
      let self = this
        self.$confirm('是否删除').then(() => {
         self.$api.deleteSaleOrder({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getSaleOrderListSearch()
          }
      })
      })
     
    },
     // 批量导入
    importSendInfo(file) {
      this.fullscreenLoading = true
      let formData = new FormData()
      formData.append('file', file)
      this.$api.imporSaleOrderTemplete(formData).then(res => {
        this.fullscreenLoading  = false
        if(res.code === 200) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
          this.getSaleOrderListSearch()
        }
      })
      return false;
    },
    getSaleOrderTemplete(){
      window.open(`/api/hjx/saleOrder/getSaleOrderTemplete`,"_blank")
    },
   
    //改变分类，品牌和等级集合发生变化
    changeOtherOptions(isQuery) {
      let self = this;
      if (isQuery) {
        this.$set(this.queryParamForm, "brandId", null);
        this.$set(this.queryParamForm, "gradeId", null);
        this.$set(this.queryParamForm, "modelId", null);
        this.$set(this, "queryModelList", []);
      } else {
        this.$set(this.editBasePriceForm, "brandId", null);
        this.$set(this.editBasePriceForm, "gradeId", null);
        this.$set(this.editBasePriceForm, "modelId", null);
        this.$set(this, "editModelList", []);
      }
      self.getBrandOptions(isQuery);
      self.getGradeList(isQuery);
    },
    //机型
    getModelList(isQuery) {
      let brandId = isQuery
        ? this.queryParamForm.brandId
        : this.editBasePriceForm.brandId;
      isQuery
        ? this.$set(this.queryParamForm, "modelId", null)
        : this.$set(this.editBasePriceForm, "modelId", null);
      if (brandId === "") {
        this.$set(this, isQuery ? "queryModelList" : "editModelList", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            brandId: brandId,
            typeKey: "phoneModal",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            isQuery
              ? (self.queryModelList = res.data.records || [])
              : (self.editModelList = res.data.records || []);
          });
      }
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getSaleOrderListSearch();
    },

    // 获取表格数据
    getSaleOrderListSearch() {
      let self = this;
      self.$api
        .getSaleOrderListSearch({
          page: self.currentPage,
          size: self.pageSize,
          categoryId: self.queryParamForm.categoryId || null,
          modelId: self.queryParamForm.modelId || null,
          brandId: self.queryParamForm.brandId || null,
          imei: self.queryParamForm.imei || null,
          isProfit: self.queryParamForm.isProfit,
          orderNo: self.queryParamForm.orderNo || null,
          saleChannel: self.queryParamForm.saleChannel || null,
          saleNo: self.queryParamForm.saleNo || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    getBrandOptions(isQuery) {
      let categoryId = isQuery
        ? this.queryParamForm.categoryId
        : this.editBasePriceForm.categoryId;

      if (categoryId === "") {
        this.$set(this, isQuery ? "queryBrandOptions" : "editBrandOptions", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            categoryId: categoryId,
            typeKey: "phoneBrand",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            isQuery
              ? (self.queryBrandOptions = res.data.records || [])
              : (self.editBrandOptions = res.data.records || []);
          });
      }
    },

    getCategroyOptions() {
      let self = this;
      this.$api
        .getClass({
          typeKey: "category",
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          self.queryCategoryOptions = res.data.records || [];
        });
    },

  },
  created() {},
  mounted() {
    let self = this;
    self.getSaleOrderListSearch();
    self.getCategroyOptions();
  },
};
</script>
<style lang="less" scoped></style>
